import { gql } from 'app/graphql';

export const GET_VIEW_COUNTS = gql(`
query GetViewCounts {
    unviewedEntities {
        activities {
            key
            value {
                actionId
                entityId
                listingId
            }
        }
        comments {
            key
            value {
                actionId
                entityId
                listingId
            }
        }
        appointments {
            key
            value {
                actionId
                entityId
                listingId
            }
        }
    }
}
`);